import { useLayoutEffect, useRef, useState } from 'react';
import { FieldHelp } from '../../../../../components/ui/FieldHelp';
import styles from './OrderPreviewDialog.module.css';

const explanation = '修改自动保存并校验，可关闭后继续处理；确认导入后生成订单，由老师手动推送给家长。';

/** Use the actual remaining title-row width, including filename and save status. */
export function OrderPreviewTitleHint() {
  const root = useRef<HTMLDivElement>(null);
  const [compact, setCompact] = useState(false);
  useLayoutEffect(() => {
    const node = root.current;
    if (!node) return;
    let active = true;
    const canvas = document.createElement('canvas');
    function measure() {
      if (!active || !node || node.clientWidth === 0) return;
      const context = canvas.getContext('2d');
      if (!context) return;
      const style = getComputedStyle(node);
      context.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
      const spacing = Number.parseFloat(style.letterSpacing) || 0;
      const textWidth = context.measureText(explanation).width + spacing * explanation.length;
      setCompact(textWidth > node.clientWidth);
    }
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver(measure);
    observer?.observe(node);
    window.addEventListener('resize', measure);
    void document.fonts?.ready.then(measure);
    return () => {
      active = false;
      observer?.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);
  return <div className={styles.titleHint} ref={root}>
    {compact ? <FieldHelp content={explanation} label="订单导入与自动保存说明" /> : <span>{explanation}</span>}
  </div>;
}
